module.exports = __webpack_public_path__ + "static/img/1a (1).88a6f53f.png";